export const profile = {
  name: 'Arpan Raj',
  roles: ['Cloud Engineer', 'Full Stack Dev', 'AWS Engineer'],
  tagline: 'Building products that scale—and systems that last.',
  location: 'Delhi',
  email: 'workwitharpanraj@gmail.com',
  github: 'https://github.com/lofynerd',
  githubUsername: 'lofynerd',
  linkedin: 'https://www.linkedin.com/in/arpan-r-2a7667422/',
  quote: '"Good architecture is invisible until it isn\u2019t there."',
}
